import { Search, Package, MessageCircle, HelpCircle, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const HelpCenter = () => {
    return (
        <div className="max-w-4xl mx-auto py-12 md:py-20 px-6">
            <h1 className="text-3xl md:text-5xl font-bold text-center mb-6">How can we help?</h1>

            {/* Search Bar */}
            <div className="max-w-2xl mx-auto relative mb-16">
                <Search className="absolute left-6 top-1/2 -translate-y-1/2 text-zinc-400" size={24} />
                <input
                    type="text"
                    placeholder="Search for answers..."
                    className="w-full pl-16 pr-6 py-5 rounded-2xl border border-zinc-200 shadow-sm focus:outline-none focus:ring-2 focus:ring-zinc-900 text-lg"
                />
            </div>

            {/* Quick Categories */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
                <Link to="/orders" className="p-6 rounded-2xl border border-zinc-100 bg-white hover:shadow-lg transition-all text-center group">
                    <div className="w-14 h-14 mx-auto bg-blue-50 text-blue-600 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                        <Package size={28} />
                    </div>
                    <h3 className="font-bold text-lg mb-2">Track Order</h3>
                    <p className="text-zinc-500 text-sm">Check shipping status</p>
                </Link>

                <Link to="/contact" className="p-6 rounded-2xl border border-zinc-100 bg-white hover:shadow-lg transition-all text-center group">
                    <div className="w-14 h-14 mx-auto bg-green-50 text-green-600 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                        <MessageCircle size={28} />
                    </div>
                    <h3 className="font-bold text-lg mb-2">Contact Support</h3>
                    <p className="text-zinc-500 text-sm">Get in touch with us</p>
                </Link>

                <Link to="/faq" className="p-6 rounded-2xl border border-zinc-100 bg-white hover:shadow-lg transition-all text-center group">
                    <div className="w-14 h-14 mx-auto bg-purple-50 text-purple-600 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                        <HelpCircle size={28} />
                    </div>
                    <h3 className="font-bold text-lg mb-2">FAQs</h3>
                    <p className="text-zinc-500 text-sm">Common questions</p>
                </Link>

                <Link to="/terms" className="p-6 rounded-2xl border border-zinc-100 bg-white hover:shadow-lg transition-all text-center group">
                    <div className="w-14 h-14 mx-auto bg-orange-50 text-orange-600 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                        <FileText size={28} />
                    </div>
                    <h3 className="font-bold text-lg mb-2">Legal/Policies</h3>
                    <p className="text-zinc-500 text-sm">Terms and Privacy</p>
                </Link>
            </div>

            {/* Common Topics */}
            <div>
                <h2 className="text-2xl font-bold mb-6">Popular Topics</h2>
                <div className="space-y-4">
                    <div className="p-5 rounded-xl border border-zinc-100 hover:bg-zinc-50 cursor-pointer flex justify-between items-center bg-white">
                        <span className="font-medium text-zinc-900">How do I return an item?</span>
                        <span className="text-blue-600 text-sm font-bold">Read Article</span>
                    </div>
                    <div className="p-5 rounded-xl border border-zinc-100 hover:bg-zinc-50 cursor-pointer flex justify-between items-center bg-white">
                        <span className="font-medium text-zinc-900">When will I receive my refund?</span>
                        <span className="text-blue-600 text-sm font-bold">Read Article</span>
                    </div>
                    <div className="p-5 rounded-xl border border-zinc-100 hover:bg-zinc-50 cursor-pointer flex justify-between items-center bg-white">
                        <span className="font-medium text-zinc-900">Can I change my delivery address?</span>
                        <span className="text-blue-600 text-sm font-bold">Read Article</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpCenter;
